(function (app) {
  $(document).ready(function () {

    app.UserLicense = function () {

      var _this = this;

      var nameSpace = 'UserLicense',
        getUrl = '/api/subuser',
        context = '.page__user-licence--container',
        dataTable = '.table__user-license-list',
        templates = {
          'userRow': app.templates["User__license____row"]
        },

        defaultPageParams = {
          'pageSize': 20,
          'pageNo': 1,
          'q': '',
          'orderBy': 'dateCreated',
          'orderByOrder': "DESC",
          'group': '',
          'queryVal': 'no-trigger',
          'query': ''
        };

      _this.validatePassword = function () {
        var passwordInformationForm = $('form[name="sub-user__form"]');

        var fields = {
          'password': $('input[name="password"]', passwordInformationForm),
          'confirm_password': $('input[name="confirm_password"]', passwordInformationForm),
        };

        var values = {
          password: $.trim(fields.password.val()),
          confirm_password: $.trim(fields.confirm_password.val())
        };

        var errors = [];

        $.each(fields, function () {
          $(this).closest('.form-group').removeClass('has-error');
        });

        if (values.password != values.confirm_password) {
          fields.confirm_password.closest('.form-group').addClass('has-error');
          errors.push('Passwords do not match');
        }

        if (_.size(errors)) {
          alertify.error(errors.join('<br>'));
          return false;
        }
        return true;
      };

      // To update Table view
      _this.updateList = function (response) {
        // Clean up all existing data in dom
        var $body = $('.table__user-license-body', $(context).context)
        $body.html('');
        $(dataTable).removeClass('loading-state');


        if (typeof response.result != 'undefined' && response.result.length) {
          _.each(response.result, function (row) {
            var userRow = _.template(templates.userRow);
            var $userRow = $(
              userRow(
                $.extend(row, {
                  'dateCreated': moment(row.dateCreated.date).format('MM/DD/YYYY @ h:mm a'),
                  'lastLogin': _.isEmpty(row.lastLogin) ? '--' : moment(row.lastLogin.date).format('MM/DD/YYYY @ h:mm a'),
                })
              )
            );
            $userRow.appendTo($body);
          });
        } else {
          $('.page__no--records').show();
        }
      };

      _this.userActions = function () {
        return {
          delete: function (userId) {
            var query = $.Deferred();
            var appTransport = app.transport();
            appTransport
              .setEvent('onSuccess', function (response) {
                return query.resolve(response);
              })
              .setEvent('onError', function (error) {
                app.flashMessenger('error', error.code + ' :: ' + error.message.message);
              })
              .setEvent('onComplete', function () {

              })
            ;
            appTransport.delete('/api/subuser/' + userId);
            return query.promise();
          },
          get: function (userId) {
            var query = $.Deferred();
            var appTransport = app.transport();
            appTransport
              .setEvent('onSuccess', function (response) {
                return query.resolve(response);
              })
              .setEvent('onError', function (error) {
                app.flashMessenger('error', error.code + ' :: ' + error.message.message);
              })
              .setEvent('onComplete', function () {

              })
            ;
            appTransport.get('/api/subuser/' + userId);
            return query.promise();
          },
        }
      };

      _this.context = function () {
        return context;
      };

      _this.storage = function () {
        return $.sessionStorage;
      }();

      _this.pageParams = function () {
        var key = nameSpace + '__pageParams';
        return {
          set: function (params) {
            var pageParams = $.extend({}, _this.storage.get(key), params);
            _this.storage.set(key, pageParams);
          },
          get: function () {
            return _this.storage.get(key);
          },
          reset: function () {
            var defaultPageParams = _this.getDefaultPageParams();
            delete defaultPageParams['pageSize'];
            delete defaultPageParams['orderBy'];
            delete defaultPageParams['orderByOrder'];
            delete defaultPageParams['group'];
            delete defaultPageParams['queryVal'];
            delete defaultPageParams['query'];
            delete defaultPageParams['q'];

            var pageParams = $.extend({}, _this.storage.get(key), defaultPageParams);
            _this.storage.set(key, pageParams);
          }
        }
      };

      _this.buildUrl = function (options) {
        options = _this.pageParams().get();

        // Customize below as per backend params required
        var queryBuilders = [];
        queryBuilders.push('page=' + options.pageNo);
        queryBuilders.push('limitPerPage=' + options.pageSize);
        !_.isEmpty(options.q) ? queryBuilders.push('q=' + options.q) : '';
        !_.isEmpty(options.type) ? queryBuilders.push('type=' + options.type) : '';
        !_.isEmpty(options.orderBy) ? queryBuilders.push('orderBy=' + options.orderBy + '&orderByOrder=' + options.orderByOrder) : '';
        !_.isEmpty(options.query) ? queryBuilders.push('query=' + options.query + '&' + $.param(options.queryParams)) : '';

        return getUrl + encodeURI('?' + queryBuilders.join('&'));
      };

      _this.getFilters = function () {
        var options = _this.pageParams().get(), filters = {};
        filters = !_.isEmpty(options.query) ? $.extend({}, {'query': options.query}, options.queryParams) : $.extend({}, {'query': 'no-trigger'});
        filters = !_.isEmpty(options.q) ? $.extend(filters, {'search': options.q}) : filters;
        return filters;
      };

      _this.getList = function (options) {
        $(dataTable).addClass('loading-state');
        $('.page__no--records').hide();

        var query = $.Deferred();
        var appTransport = app.transport();

        appTransport
          .setEvent('onSuccess', function (response) {
            _this.updateList(response);
            return query.resolve(response);
          })
          .setEvent('onError', function (error) {
            app.flashMessenger('error', error.code + ' :: ' + error.message.message);
            return query.reject(error);
          })
          .setEvent('onComplete', function () {

          })
        ;
        appTransport.get(_this.buildUrl(options));
        return query.promise();
      };


      _this.getDefaultPageParams = function () {
        return $.extend({}, {
          'orderBy': $(dataTable).attr('data-orderBy'),
          'orderByOrder': $(dataTable).attr('data-orderByOrder')
        }, defaultPageParams);
      };

      return {
        init: function () {
          // Set Page Params to default or from storage
          _.isNull(_this.pageParams().get()) ? _this.pageParams().set(_this.getDefaultPageParams()) : null;

          // Set sorting on sales team
          $('.table__user-license-list').mdcSort({
            'orderBy': _this.pageParams().get()['orderBy'],
            'orderByOrder': _this.pageParams().get()['orderByOrder'],
            callback: function (obj) {
              var pageParams = {orderBy: obj.orderBy, orderByOrder: obj.orderByOrder};
              _this.pageParams().set(pageParams);
              _this.getList();
            }
          });


          // Get User Licenses
          $.when(_this.getList()).done(function (response) {

          });


          $(document).off('click.user__list--action').on('click.user_list-action', context + ' [data-action]', function (e) {
            var action = $(this).attr('data-action'),
              userId = $(this).attr('data-id'),
              $button = $(this),
              $dataRow = $(this).closest('[data-row]'),
              $modal = $('[data-modal-sub-user]'),
              message = "User Name :: " + $dataRow.find('.col__name').html();

            switch (action) {

              case 'trash':
                $button.button('loading');
                var $confirmOk = $('.ajs-button.ajs-ok');
                alertify.confirm()
                  .set({
                    labels: {
                      ok: "Delete"
                    }
                  })
                  .set({reverseButtons: true, transition: 'zoom', 'modal': true})
                  .setHeader('Confirm Content Delete')
                  .set('message', message)
                  .set('onok', function (e) {
                    e.cancel = true;
                    $confirmOk.button('loading');
                    if (typeof userId != 'undefined' && userId != '') {
                      var userDelete = _this.userActions().delete(userId);
                      $.when(userDelete).done(function () {
                        alertify.confirm().close();
                        $confirmOk.button('reset');
                        app.redirect('/my-account/app-user/user-licenses', true);
                      }).fail(function () {
                        $button.button('reset');
                      });
                    }

                  })
                  .set('oncancel', function () {
                    $button.button('reset');
                  })
                  .show();
                break;

              case 'add' :
                var $form = $('form[name="sub-user__form"]');
                $form.find(':input[name="id"]').val('');
                $form.find(':input[name="firstname"]').val('');
                $form.find(':input[name="lastname"]').val('');
                $form.find(':input[name="phone"]').val('');
                $form.find(':input[name="email"]').val('');
                $form.find(':input[name="timezone"]').val('');
                $form.find(':input[name="password"]').val('');
                $form.find(':input[name="confirm_password"]').val('');
                $modal.modal('show');
                break;

              case 'edit' :
                $.when(_this.userActions().get(userId)).done(function (response) {
                  response = response.user;
                  var $form = $('form[name="sub-user__form"]');
                  $form.find(':input[name="id"]').val(response.id);
                  $form.find(':input[name="firstname"]').val(response.firstname);
                  $form.find(':input[name="lastname"]').val(response.lastname);
                  $form.find(':input[name="phone"]').val(response.phone);
                  $form.find(':input[name="email"]').val(response.email);
                  $form.find(':input[name="timezone"]').val(response.timezone);
                  $form.find(':input[name="password"]').val('');
                  $form.find(':input[name="confirm_password"]').val('');
                  $modal.modal('show');
                }).fail(function () {
                  $button.button('reset');
                });
                $modal.modal('show');
                break;
            }

          }).off('submit.' + nameSpace).on('submit.' + nameSpace, context + ' form[name="sub-user__form"]', function (e) {
            var $form = $('form[name="sub-user__form"]');
            var $modal = $('[data-modal-sub-user]');
            var $submitButton = $('button[type=submit]', $form);
            var appTransport = app.transport();
            var requestData = $form.serializeObject();
            var id = parseInt($.trim(requestData.id));

            if (_.isEmpty($.trim(requestData.email))) {
              app.flashMessenger('error', 'Email is required');
              return e.preventDefault();
            }

            if (_.isEmpty($.trim(requestData.timezone))) {
              app.flashMessenger('error', 'Timezone is required');
              return e.preventDefault();
            }

            if (_this.validatePassword() == false)  return e.preventDefault();

            delete requestData.confirm_password;
            delete requestData.id;

            $submitButton.button('loading');
            appTransport
              .setEvent('onSuccess', function (response) {
                if (response.success) {
                  if (id) {
                    app.flashMessenger('success', 'User Updated Successfully');
                  } else {
                    app.flashMessenger('success', 'User Saved Successfully');
                  }
                  $modal.modal('hide');
                  app.redirect('/my-account/app-user/user-licenses', true);
                  
                } else {
                  app.flashMessenger('error', 'Error saving user');
                }

              })
              .setEvent('onError', function (error) {
                app.flashMessenger('error', error.code + '::' + error.message.message);
              })
              .setEvent('onComplete', function () {
                $submitButton.button('reset');
              })
            ;

            if (id) {
              appTransport.put('/api/subuser/' + id, requestData);
            } else {
              appTransport.post('/api/subuser', requestData);
            }

            return e.preventDefault();
          });

        },
        global: function () {
          $(document).off('click.switch-account-modal--' + 'Global').on('click.switch-account-modal--' + 'Global', '[data-switch-account-modal-trigger]', function (e) {
            e.preventDefault();
            var $modal = $('[data-switch-account-modal]');
            var appTransport = app.transport();
            var $select = $modal.find('select');
            $select.find('option').remove();

            appTransport
              .setEvent('onSuccess', function (response) {
                $('[data-switch-account-modal-trigger]').removeClass('d-none');
                _.each(response.list, function (row) {
                  var $option = $('<option> </option>').appendTo($select);
                  $option.text(row.email + ' | ' + row.name);
                  $option.val(row.id);
                });

                $modal.find('[data-name]').text(response.session.name);
                $modal.find('[data-email]').text(response.session.email);

                var $btnManageUsers = $modal.find('.btn-manage-users');
                if (response.session.masterAccount === true) {
                  $btnManageUsers.show();
                  $modal.find('[data-user-type]').text('Primary Account');
                } else {
                  $btnManageUsers.hide();
                  $modal.find('[data-user-type]').text('Sub User Account');
                }

              })
              .setEvent('onError', function (error) {

              })
              .setEvent('onComplete', function () {

              })
            ;
            appTransport.get('/api/subuser/all');
            $modal.modal('show');

          }).off('click.switch-account--' + 'Global').on('click.switch-account--' + 'Global', '[data-confirm-switch]', function (e) {
            var $modal = $('[data-switch-account-modal]');
            var appTransport = app.transport();
            var $select = $modal.find('select');
            var $submit = $(this);
            $submit.button('loading');
            appTransport
              .setEvent('onSuccess', function (response) {
                window.location.reload(true);
              })
              .setEvent('onError', function (error) {
                app.flashMessenger('error', error.code + ' :: ' + error.message.message);
              })
              .setEvent('onComplete', function () {
                $submit.button('reset');
              })
            ;
            appTransport.post('/api/user/switch-account', {id: $select.val()});

          });

        }
      };
    };

  });
})(PreBuilt);


// Call  global check for social connect
(function (app) {
  $(document).ready(function () {
    var appUserLicense = new app.UserLicense();
    appUserLicense.global();
  });
})(PreBuilt);


